import React from 'react';
import Visionn from './Visionn';
import Testimonialsabout from './Testimonialsabout';

const Aboutus = () => {
  return (
    <>
      <section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light">About Us</h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


    <section>
      <div className="container">
        <div className="row align-items-center justify-content-between g-4">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div>
              <h2 className="lh-base fs-1 fw-bold">Who We're & Mission?</h2>
              <p>
              At Skyline Cabs, we are passionate about providing our customers with a seamless, reliable, and luxurious travel experience. With a fleet that spans from compact cars to elegant SUVs and spacious sedans, and a team of highly skilled, professional drivers, we ensure that every trip is not just a ride but an experience.

Since our inception, we’ve been dedicated to offering safe, smooth, and comfortable journeys for individuals and groups alike. Whether it’s a quick city commute, a long-distance trip between cities, airport transfers, corporate travel, or a customized outstation tour, Skyline Cabs tailors every service to suit your specific needs.

We pride ourselves on reliability and punctuality, offering flexible, hassle-free booking options, and affordable pricing without compromising on quality. Our commitment to customer satisfaction is at the core of everything we do. We aim to deliver not just a ride, but a stress-free and enjoyable experience that exceeds expectations.<br/>

From smooth rides in our well-maintained fleet to professional drivers committed to your safety and comfort, we focus on making every journey as pleasant as possible. Our easy-to-use online booking system and 24/7 availability make booking your ride effortless, so you can focus on what matters most.

Skyline Cabs is more than just a travel service – it’s a trustworthy partner for all your travel needs. Let us take you places with comfort, convenience, and care.
              </p>
         
            </div>
          </div>

          <div className="col-xl-5 col-lg-6 col-md-6">
            <div className="position-relative">
              <img src="https://www.vighnahartatravels.in/images/1)%20Kia%20Carens%20Cabs%20on%20Rent%20in%20Pune.webp" className="img-fluid" alt="Side Image" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Visionn/>
    <Testimonialsabout/>
    </>
  );
};

export default Aboutus;
